"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.mapListing = exports.cleanTitle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source))).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

// Actually contains more fields but we don't want to ever use them
// Actually contains more fields but we don't want to ever use them
// Actually contains more fields but we don't want to ever use them
var mustHaveDimensions = function mustHaveDimensions(x) {
  return x.height && x.width;
};

var replaceBadChar = function replaceBadChar(c) {
  return "%".concat(c.charCodeAt(0).toString(16));
};

var fixImageUrls = function fixImageUrls(image) {
  return _objectSpread(_objectSpread({}, image), {}, {
    url: image.url.replace(/[!'()*]/g, replaceBadChar)
  });
};

var replaceDimensions = function replaceDimensions(_, dimensions) {
  return "".concat(dimensions, "m\xB2");
};

var replaceExtraSpace = function replaceExtraSpace(_, word, punc) {
  var _context;

  return (0, _concat.default)(_context = "".concat(word)).call(_context, punc);
};

var addMissingSpace = function addMissingSpace(_, punc, word) {
  var _context2;

  return (0, _concat.default)(_context2 = "".concat(punc, " ")).call(_context2, word);
};

var fixInconsistentHyphens = function fixInconsistentHyphens(_, a, b) {
  return a ? "".concat(a, " - ") : " - ".concat(b);
};
/**
 * Sanitisation function to make some of the more crazy listing titles a
 * little less so.
 */


var cleanTitle = function cleanTitle(title) {
  return title && title // Replace multiple exclamation marks with one
  .replace(/!{2,}/g, '!') // Replace 3+ periods with an ellipsis
  .replace(/\.{3,}/g, '…') // Replace square metre dimensions with m²
  .replace(/([\d,]+)\s*(m2|sqm)\b/gi, replaceDimensions) // Replace multiple spaces with one
  .replace(/\s{2,}/g, ' ') // Remove extra space between words and punctuation
  .replace(/(\w)\s([,!.?])/g, replaceExtraSpace) // Add space where missing between words and punctuation
  .replace(/([,!.…])([a-zA-Z])/, addMissingSpace) // Correct inconsistent hypenation
  .replace(/(?:([a-zA-Z0-9])-\s|\s-([a-zA-Z0-9]))/, fixInconsistentHyphens);
};

exports.cleanTitle = cleanTitle;

var mapListing = function mapListing(data) {
  var _context3;

  // Extract non-compatible types
  var nzExtraFeatures = data.nzExtraFeatures,
      _data$translations = data.translations,
      translations = _data$translations === void 0 ? [] : _data$translations,
      _data$images = data.images,
      images = _data$images === void 0 ? [] : _data$images,
      address = data.address,
      _private = data._private,
      rest = (0, _objectWithoutProperties2.default)(data, ["nzExtraFeatures", "translations", "images", "address", "_private"]);

  if (address.location) {
    // Clean up crappy address location data
    var _address$location = address.location,
        lat = _address$location.lat,
        lon = _address$location.lon;
    address.location = lat && lon && lat !== -1 && lon !== -1 ? address.location : undefined;
  }

  var listing = _objectSpread(_objectSpread({
    measurements: [],
    rates: [],
    inspections: [],
    categories: [],
    features: [],
    agents: [],
    attachments: [],
    clearingSaleItems: [],
    floorTypes: [],
    links: [],
    plans: [],
    regions: [],
    private: _private
  }, rest), {}, {
    listingId: data.id,
    address,
    title: cleanTitle(data.title),
    images: (0, _map.default)(_context3 = (0, _filter.default)(images).call(images, mustHaveDimensions)).call(_context3, fixImageUrls),
    translations: (0, _reduce.default)(translations).call(translations, function (set, trans) {
      var description = trans.description,
          title = trans.title,
          languageCode = trans.languageCode; // eslint-disable-next-line no-param-reassign

      set[languageCode] = {
        description,
        title
      };
      return set;
    }, {}),
    // Rename the nzExtraFeatures field to something more general.
    extraFeatures: nzExtraFeatures || {}
  });

  return listing;
};

exports.mapListing = mapListing;